import eth from "@/assets/image/eth.svg";
import React from "react";
import "./index.css";

const EthImage: React.FC<{ type?: "defualt" | "large" }> = (props) => {
  const { type = 'defualt' } = props;
  const cls = `eth_${type}`;
  return <img className={cls} src={eth} alt="" />;
};

export default EthImage;
